function radioCondition(el) {
  const id = el.dataset.radio;
  const radio = document.getElementById(id);

  radio.addEventListener('change', e => {
    const idStart = id.substr(0, id.length - radio.value.length - 1)
    const otherRadioInGroup = document.querySelectorAll(`[id^=${idStart}]`);

    for (let i = 0; i < otherRadioInGroup.length; ++i) {
      const el = document.querySelector(`[data-radio="${otherRadioInGroup[i].id}"]`);

      if (el) {
        el.style.display = 'none';
      }
    }

    el.style.display = radio.value;
    el.style.display = radio.checked ? 'block' : 'none';
  });

  radio.dispatchEvent(new Event('change'));
}

function radioConditionTrigger() {
  const radioConditions = document.querySelectorAll('[data-radio]');

  for (let i = 0; i < radioConditions.length; i++) {
    const id = radioConditions[i].dataset.radio;
    const radio = document.getElementById(id);

    if (radio) {
      radio.dispatchEvent(new Event('change'));
    }
  }
}

export default () => {
  const radioConditions = document.querySelectorAll('[data-radio]');

  for (let i = 0; i < radioConditions.length; i++) {
    radioCondition(radioConditions[i])
  }

  window.radioConditionTrigger = radioConditionTrigger;
}



// WEBPACK FOOTER //
// ./themes/app/assets/js/forms.js